export default { // 抽检-操作说明：该需求运行在评估师App: 车源稽查管理 -》 操作说明
  tabs: [
    {
      name: 'SpotCheckOperateExplain',
      path: '/spotCheckOperateExplain',
      component: () => import('./src/index.vue'),
      meta: {
        title: '操作说明',
        isMenu: true,
        openNetwork: true
      }
    }
  ]
}
